import { withInstallFunction } from '@lit-element/utils'

import Message from './src/method'

export const LtMessage = withInstallFunction(Message, '$message')
export default LtMessage

export * from './src/message'
